import { Directive, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MenuItemSizeDto } from "src/app/api/v1/models";

@Directive()
export abstract class SizePickerAbstract implements OnInit {
  @Input() sizes: MenuItemSizeDto[];
  @Output() pickSize: EventEmitter<MenuItemSizeDto> = new EventEmitter<MenuItemSizeDto>()

  currentSize: MenuItemSizeDto;

  ngOnInit(): void {
    const defaultSize = this.sizes.find(size => size.isDefault);
    this.currentSize = defaultSize ?? this.sizes[0];
  }

  onChangeSize(size: MenuItemSizeDto): void {
    this.currentSize = size;
    this.pickSize.emit(size)
  }
}